<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список лицензий</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактировать лицензию</li>
        </ol>
    </nav>

    <div class="inform col-12">
        <div class="form-row">
            <div class="col-md-4">
                <label for="key-license">Ключ лицензии</label>
                <div class="d-flex align-items-center">
                    <span class="me-3">
                        {{ forms.license.key }}
                    </span>
                    <button
                        style="padding:5px;min-width:50px;width:10px;background-color:white;border:1px solid #e6e6e6;"
                        title="Скопировать ключ"
                        class="btn btn-lg"
                        @click="copyLicenseKey()">
                        <svg style="width: 20px;" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                            <path d="M384 96L384 0h-112c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48H464c26.51 0 48-21.49 48-48V128h-95.1C398.4 128 384 113.6 384 96zM416 0v96h96L416 0zM192 352V128h-144c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h192c26.51 0 48-21.49 48-48L288 416h-32C220.7 416 192 387.3 192 352z"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <div class="col-md-6 mb-3">
            <label class="form-label">Устройство</label>
            <div class="app-dropdown">
                <div @click="openDropDown()" class="manager">
                    <div class="button">
                        <div v-if="forms.searchingDevices.selectedItem">
                            {{ forms.searchingDevices.selectedItem.pharmacy_number }},
                            {{ forms.searchingDevices.selectedItem.address }},
                            {{ forms.searchingDevices.selectedItem.type }} {{ forms.searchingDevices.selectedItem.item }}
                        </div>
                    </div>
                </div>
                <div
                    v-bind:class="{
                            hidden: !forms.searchingDevices.openDropDown,
                            open: forms.searchingDevices.openDropDown
                        }"
                    class="content"
                >
                    <div class="items-block">

                        <div class="items">
                            <div class="searching-block">
                                <input
                                    @keyup.enter="onSearchDevices()"
                                    @keyup.delete="onCancelSearchDevices()"
                                    v-model="forms.searchingDevices.searchingControl"
                                    type="text"
                                    class="form-control"
                                    placeholder="Поиск">
                            </div>
                            <div class="item"
                                 @click="selectDevice(device)"
                                 v-for="device in forms.searchingDevices.devices"
                                 :value="device">

                                {{ device.pharmacy_number }},
                                {{ device.address }},
                                {{ device.type }} {{ device.item }}
                            </div>
                        </div>

                    </div>
                    <div
                        @click="closeDropDown()"
                        v-bind:class="{
                                hidden: !forms.searchingDevices.openDropDown,
                                open: forms.searchingDevices.openDropDown
                            }"
                        class="shade"
                    >
                    </div>
                </div>
            </div>
            <div class="p-1">
                <label class="form-label mt-3">Клиент</label>
                <div v-if="forms.searchingDevices.selectedItem">
                    {{ forms.searchingDevices.selectedItem.client_name }}
                </div>
                <label class="form-label mt-3">Бренд</label>
                <div v-if="forms.searchingDevices.selectedItem">
                    {{ forms.searchingDevices.selectedItem.brand_name }}
                </div>
                <label class="form-label mt-3">Организация</label>
                <div v-if="forms.searchingDevices.selectedItem">
                    {{ forms.searchingDevices.selectedItem.org_name }}
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-4">
                <label class="form-label">Договор</label>
                <div class="app-dropdown">
                    <div @click="openDropDownSearchingContracts()" class="manager">
                        <div class="button">
                            <div v-if="forms.searchingContracts.selectedItem && forms.searchingContracts.selectedItem.contract_id">
                                {{ forms.searchingContracts.selectedItem.contract_name }}
                                № {{ forms.searchingContracts.selectedItem.contract_number }}
                            </div>
                        </div>
                    </div>
                    <div
                        v-bind:class="{
                            hidden: !forms.searchingContracts.openDropDown,
                            open: forms.searchingContracts.openDropDown
                        }"
                        class="content"
                    >
                        <div class="items-block">

                            <div class="items">
                                <div class="searching-block">
                                    <input
                                        @keyup.enter="onSearchContracts()"
                                        @keyup.delete="onCancelSearchContracts()"
                                        v-model="forms.searchingContracts.searchingControl"
                                        type="text"
                                        class="form-control"
                                        placeholder="Поиск"
                                    >
                                </div>
                                <div
                                    class="item"
                                    @click="selectContracts(item)"
                                    v-for="item in forms.searchingContracts.items"
                                    :value="item"
                                >
                                    {{ item.contract_name }} № {{ item.contract_number }}
                                </div>
                            </div>

                        </div>
                        <div
                            @click="closeDropDownSearchingContracts()"
                            v-bind:class="{
                                hidden: !forms.searchingContracts.openDropDown,
                                open: forms.searchingContracts.openDropDown
                            }"
                            class="shade"
                        >
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-3">
                <label for="license-pay">Стоимость в месяц</label>
                <input
                    type="text"
                    class="form-control"
                    id="license-pay"
                    v-model="license.pay_per_month.value"
                    placeholder="Введите стоимость лицензии"
                >
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-4">
                <label for="device-expires_at">Период действия</label>
                <select @change="onChangeValidity($event)" class="form-select" v-model="forms.validity.selected">
                    <option value="1">
                        Cрочная – на год
                    </option>
                    <option value="2">
                        Бессрочная
                    </option>
                    <option value="3">
                        Указать в ручную
                    </option>
                </select>
                <div v-if="forms.validity.selected == 3" class="mt-3 d-flex align-items-center justifully-content-center">
                    <input
                        type="date"
                        class="form-control w-75"
                        id="created-license"
                        v-model="forms.validity.createdLicense"
                        @change="onChangeCreatedLicense($event)">
                    <input
                        type="date"
                        class="form-control w-75 ms-1"
                        id="expires-at"
                        v-model="forms.validity.expiresAt"
                        @change="onChangeExp($event)">
                </div>
                <div v-if="forms.validity.selected == 1" class="mt-3 d-flex align-items-center justifully-content-center">
                    <input
                        type="date"
                        class="form-control w-75"
                        id="created-license"
                        v-model="forms.validity.createdLicense"
                        @change="onChangeCreatedLicense($event)">
                    <input
                        type="date"
                        class="form-control w-75 ms-1"
                        id="expires-at"
                        v-model="forms.validity.expiresAt"
                        disabled>
                </div>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-3">
                <label for="device-expires_at">Статус оплаты</label>
                <select @change="onChangeStatusPayment($event)" class="form-select" v-model="forms.statusPay.selected">
                    <option value="1">
                        Не оплачено
                    </option>
                    <option value="2">
                        Выставлен счет
                    </option>
                    <option value="3">
                        Оплачено
                    </option>
                </select>
            </div>
        </div>

        <div class="d-flex w-50 align-items-center justify-content-start ms-1">
            <button class="btn btn-lg btn-primary me-3" v-on:click="onUpdateLicense()">
                Обновить
            </button>
            <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
        </div>
    </div>

    <Alert />
</template>

<script>
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "LicenseEditComponent",
    components: { Alert },
    props: {
        route_back: String,
        route_get: String,
        route_update: String,
        license_id: {
            type: [Number, String],
            default: 0
        }
    },
    data: function () {
        return {
            license: {
                id: {
                    value: null,
                    desc: null
                },
                device_id: {
                    value: null,
                    desc: "Вы не выбрали устройство",
                },
                type: {
                    value: null,
                    desc: "Вы не выбрали период действия",
                },
                expires_at: {
                    value: null,
                    desc: "Вы не выбрали период действия",
                },
                status_payment: {
                    value: null,
                    desc: "Вы не выбрали статус платежа",
                },
                pay_per_month: {
                    value: null,
                    desc: "Вы не ввели стоимость лицензии",
                },
                contract_id: {
                    value: null,
                    desc: "Вы не выбрали договор",
                },
                created_at: {
                    value: null,
                    desc: "Вы не выбрали период действия",
                }
            },
            forms: {
                searchingDevices: {
                    openDropDown: false,
                    devices: [],
                    selectedItem: null,
                    searchingControl: null,
                    payPerMonth: null
                },
                validity: {
                    selected: null,
                    createdLicense: null,
                    expiresAt: null
                },
                statusPay: {
                    selected: null
                },
                searchingContracts: {
                    openDropDown: false,
                    items: [],
                    selectedItem: null,
                    searchingControl: null,
                    payPerMonth: null
                },
                license: {
                    key: null,
                    isNavigator: navigator && navigator.clipboard && navigator.clipboard.writeText
                }
            },
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        onChangeStatusPayment: function(e) {
            this.license.status_payment.value = e.target.value;
        },
        onChangeCreatedLicense: function(e) {
            const selectedCreatedDate = e.target.value;

            if (!selectedCreatedDate) {
                this.forms.validity.expiresAt = null;
                this.forms.createdLicense = null;

                this.license.expires_at.value = null;
                this.license.created_at.value = null;
            }

            if (selectedCreatedDate) {
                if (this.forms.validity.selected == 1) {
                    const date = new Date(selectedCreatedDate);

                    this.forms.validity.expiresAt = this.parseDate(date, 1, 1, 0);

                    this.license.expires_at.value = this.forms.validity.expiresAt;
                    this.license.created_at.value = selectedCreatedDate;
                }

                if (this.forms.validity.selected == 3) {
                    const created = new Date(selectedCreatedDate);
                    const exp = new Date(this.forms.validity.expiresAt);

                    if (exp && exp.getTime() > created.getTime()) {
                        this.license.expires_at.value = this.forms.validity.expiresAt;
                        this.license.created_at.value = selectedCreatedDate;
                    }

                    if (!exp || exp.getTime() <= created.getTime()) {
                        this.license.expires_at.value = null;
                        this.license.created_at.value = null;
                    }
                }
            }
        },
        onChangeExp: function (e) {
            const selectedExp = e.target.value;

            if (!selectedExp) {
                this.license.expires_at.value = null;
            }

            if (selectedExp) {
                const created = new Date(this.forms.validity.createdLicense);
                const exp = new Date(selectedExp);

                if (created && created.getTime() < exp.getTime()) {
                    this.license.expires_at.value = selectedExp;
                }

                if (!created || created.getTime() > exp.getTime()) {
                    this.license.expires_at.value = null;
                    this.forms.validity.expiresAt.value = null;
                }
            }
        },
        parseDate: function (date, years, months, days) {
            if (!date) {
                return null;
            }

            const dateString = `${date.getFullYear() + years}-${date.getMonth() + months}-${date.getDate() + days}`;
            return dateString.split('-').map((el) => {
                if (parseInt(el) < 10) {
                    return `0${el}`;
                }

                return el;
            }).join('-').trim();
        },
        onChangeValidity: function (e) {
            const today = new Date()

            const selectedPeriod = e.target.value;

            this.forms.validity.createdLicense = selectedPeriod == 1 ? this.parseDate(today, 0, 1, 0) : this.forms.validity.createdLicense;
            this.forms.validity.createdLicense = selectedPeriod == 2 ? this.parseDate(today, 0, 1, 0) : this.forms.validity.createdLicense;
            this.forms.validity.createdLicense = selectedPeriod == 3 ? this.parseDate(today, 0, 1, 0) : this.forms.validity.createdLicense;

            this.forms.validity.expiresAt = selectedPeriod == 1 ? this.parseDate(today, 1, 1, 0) : this.forms.validity.expiresAt;
            this.forms.validity.expiresAt = selectedPeriod == 2 ? this.parseDate(today, 20, 1, 0) : this.forms.validity.expiresAt;
            this.forms.validity.expiresAt = selectedPeriod == 3 ? null : this.forms.validity.expiresAt;

            this.license.expires_at.value = this.forms.validity.expiresAt;
            this.license.created_at.value = this.forms.validity.createdLicense;
            this.license.type.value = selectedPeriod;
        },
        onSearchDevices: async function () {
            await this.getDevices();
        },
        getDevices: async function () {
            const data = await axios.get('/organizational/devices/list', {params: {
                    search: this.forms.searchingDevices.searchingControl,
                    limit: 50,
                    page: 1
                }}).then(resp => {
                return resp.data
            }).catch(_ => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список устройств, что-то пошло не так' });
            });

            if (data.status == 'ok') {
                this.forms.searchingDevices.devices = data.items;
            }

            if (data.status != 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список устройств' });
            }
        },
        onCancelSearchDevices: async function () {
            if (this.forms.searchingDevices.searchingControl.trim() == '') {
                await this.getDevices();
            }
        },
        selectDevice: function (device) {
            this.forms.searchingDevices.selectedItem = device;
            this.forms.searchingDevices.openDropDown = false;
            this.forms.searchingDevices.payPerMonth = device.pay_per_month;

            this.license.device_id.value = this.forms.searchingDevices.selectedItem.id;
            this.license.pay_per_month.value = this.forms.searchingDevices.payPerMonth;
        },
        closeDropDown: function () {
            this.forms.searchingDevices.openDropDown = false;
        },
        openDropDown: async function () {
            await this.getDevices();
            this.forms.searchingDevices.openDropDown = true;
        },
        getLicense: async function () {
            const data = await axios.get('/documents/licenses/get', {
                params: {
                    id: this.license_id
                }
            }).then(resp => {
                return resp.data
            }).catch(_ => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить лицензию, что-то пошло не так' });
            });

            if (data.status == 'ok') {
                this.forms = {
                    searchingDevices: {
                        openDropDown: false,
                        devices: [],
                        selectedItem: {
                            pharmacy_number: data.item.pharmacy_number,
                            address: data.item.address,
                            type: data.item.type,
                            item: data.item.item,
                            id: data.item.device_id,
                            client_name: data.item.client_name,
                            brand_name: data.item.brand_name,
                            org_name: data.item.org_name
                        },
                        payPerMonth: data.item.pay_per_month,
                        searchingControl: null,
                    },
                    searchingContracts: {
                        openDropDown: false,
                        items: [],
                        selectedItem: {
                            contract_id: data.item.contract_id,
                            contract_name: data.item.contract_name,
                            contract_number: data.item.contract_number,
                            contract_date: data.item.contract_date,
                        },
                        searchingControl: null,
                        payPerMonth: null
                    },
                    validity: {
                        selected: data.item.lisense_type,
                        createdLicense: data.item.created_at,
                        expiresAt: data.item.expires_at
                    },
                    statusPay: {
                        selected: data.item.status_payment
                    },
                    license: {
                        key: data.item.key
                    }
                };

                this.license = {
                    id: {
                        value: data.item.id,
                        desc: null
                    },
                    device_id: {
                        value: data.item.device_id,
                        desc: "Вы не выбрали устройство",
                    },
                    type: {
                        value: data.item.lisense_type,
                        desc: "Вы не выбрали период действия",
                    },
                    expires_at: {
                        value: data.item.expires_at,
                        desc: "Вы не выбрали период действия",
                    },
                    status_payment: {
                        value: data.item.status_payment,
                        desc: "Вы не выбрали статус платежа",
                    },
                    pay_per_month: {
                        value: data.item.pay_per_month,
                        desc: "Вы не ввели стоимость лицензии",
                    },
                    contract_id: {
                        value: data.item.contract_id,
                        desc: "Вы не выбрали договор",
                    },
                    created_at: {
                        value: data.item.created_at,
                        desc: "Вы не выбрали период действия",
                    }
                }
            }

            if (data.status != 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: data.message });
            }
        },
        onUpdateLicense: async function () {
            for (const prop in this.license) {
                if (!this.license[prop].value) {
                    console.log(this.license[prop])
                    this.addAlert({ type: 'info', title: 'Уведомление', text: this.license[prop].desc });
                    return;
                }
            }

            const data = await axios.post('/documents/licenses/update', {
                'id': this.license.id.value,
                'created_at': this.license.created_at.value,
                'device_id': this.license.device_id.value,
                'expires_at': this.license.expires_at.value,
                'pay_per_month': this.license.pay_per_month.value,
                'status_payment': this.license.status_payment.value,
                'type': this.license.type.value,
                'contract_id': this.license.contract_id.value
            }).then(resp => {
                return resp.data
            }).catch(_ => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось обновить лицензию, что-то пошло не так' });
            });

            if (data.status == 'ok') {
                this.addAlert({ type: 'success', title: 'Успешно', text: 'Лицензия успешно обновлена' });
                window.location.href = this.route_back;
            }

            if (data.status != 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: data.message });
            }
        },
        copyLicenseKey: async function() {
            await navigator.clipboard.writeText(this.forms.license.key);
            this.addAlert({ type: 'success', title: 'Успешно', text: 'Ключ лицензии скопирован' });
        },
        getContracts: async function () {
            const resp = await axios.get('/documents/contracts/list', {params: {
                    page: 1,
                    limit: 60,
                    search: this.forms.searchingContracts.searchingControl
                }}).catch(res => {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список договоров, что-то пошло не так' });
            });

            if (resp.data.status != 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
            }

            if (resp.data.status == 'ok') {
                this.forms.searchingContracts.items = resp.data.items;
            }
        },
        selectContracts: function (contract) {
            this.forms.searchingContracts.selectedItem = contract;
            this.forms.searchingContracts.openDropDown = false;
            this.license.contract_id.value = contract.contract_id;
        },
        closeDropDownSearchingContracts: function () {
            this.forms.searchingContracts.openDropDown = false;
        },
        openDropDownSearchingContracts: async function () {
            await this.getContracts();
            this.forms.searchingContracts.openDropDown = true;
        },
        onSearchContracts: async function () {
            await this.getContracts();
        },
        onCancelSearchContracts: async function () {
            if (this.forms.searchingContracts.searchingControl.trim() == '') {
                await this.getContracts();
            }
        },
    },
    mounted() {
        this.getLicense();
    }
}
</script>

<style scoped>
.app-dropdown {
    border-radius: 5px;
    position: relative;
}

.app-dropdown .manager {
    border: 1px solid #ddd;
    border-radius: 4px;
}

.app-dropdown .items-block {
    position: relative;
    height: 200px;
    overflow: auto;
    z-index: 9999;
    background-color: #fff;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}

.app-dropdown .items-block .searching-block {
    position: sticky;
    top: 0;
    background-color: #fff;
}

.app-dropdown .items-block .searching-block input {
    border-bottom: 1px solid #ddd;
    border-top: none;
    border-radius: 0;
    border-left: none;
    border-right: none;
}

.app-dropdown .items {
    position: absolute;
    width: 100%;
}

.app-dropdown .items .item {
    padding: 0 10px;
    cursor: pointer;
    font-size: 16px;
}

.app-dropdown .items .item:hover {
    background-color: #3c7af0;
    color: white;
}

.app-dropdown .hidden {
    display: none;
}

.app-dropdown .manager {
    padding: 15px;
    height: 40px;
    cursor: pointer;
}

.app-dropdown .manager .button {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACeSURBVHgBjZDBDcMgDEVtqwN0hK7QETpCb8ClZYNkhG6QbtAb147ABs0G7Qg5coJ+okSKEFJAQthf/9nG7Jy7E9GJGo+IfA94PTN/8B4bmCnGeBat9S+ldG0ACIDNfskJAg+h32F6Y8x7HnFVIAzo+Ki5s66UGtacSwMW88Ifb5uRnijYbT1SQiGEDpXHpcNYAlXIWjsBvCD0uNUF/QEMBD/7Z34xowAAAABJRU5ErkJggg==");
    background-repeat: no-repeat;
    background-position: center right;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 16px;
}

.app-dropdown .shade {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 999;
    min-height: 100vh;
    overflow: hidden;
}

.app-dropdown .content {
    position: absolute;
    width: 100%;
    height: 200px;
}

.app-dropdown .disable {
    background-color: #ddd;
    cursor: initial;
}
</style>
